import { createRouter, createWebHistory, type Router } from 'vue-router'
import DocumentDetailsView from '@/views/DocumentDetailsView.vue'

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/:hash',
      name: 'documentDetails',
      component: DocumentDetailsView
    },
    {
      path: '/:hash/report-fraud',
      name: 'reportFraud',
      component: () => import('../components/features/fraud-report/FraudReportView.vue')
    }
  ]
})

export default router
